import Payment from 'payment';
import { object, string, StringSchema } from 'yup';

import { intl } from '../../lib/translation/TranslationProvider';
import { validationMessages } from '../../modules/localization/validationMessages';
import { constantString } from '../../utils/yup.utils';
import { PaymentAccountType } from '../../graphql/types.generated';

export const ZIP_CODE_LENGTH = 5;

const cardNumberSchema: StringSchema = string().test(
  'card-number',
  intl.formatMessage(validationMessages['validation:form:card-number:general']),
  (value) => (value ? Payment.fns.validateCardNumber(value) : false),
);

// TODO: default('') is a temporary solution for the doubled error message when required is present
export const CreditCardSchema = object({
  accountType: constantString(PaymentAccountType.Credit).default(PaymentAccountType.Credit),
  cardNumber: cardNumberSchema.default(''),
  expirationDate: string()
    .default('')
    .test(
      'expiration-date',
      intl.formatMessage(validationMessages['validation:form:card-expiration:general']),
      (value) => (value ? Payment.fns.validateCardExpiry(value) : false),
    ),
  cvv: string()
    .default('')
    .test('cvv', intl.formatMessage(validationMessages['validation:form:card-cvv:general']), (value) =>
      value ? Payment.fns.validateCardCVC(value) : false,
    ),
  cardholderName: string().required(intl.formatMessage(validationMessages['validation:form:cardholder-name:required'])),
  zipCode: string()
    .default('')
    .matches(
      new RegExp(`^\\d{${ZIP_CODE_LENGTH}}$`),
      intl.formatMessage(validationMessages['validation:form:zip-code:general']),
    ),
});

export const PrepaidCardSchema = object({
  accountType: constantString(PaymentAccountType.Prepaid).default(PaymentAccountType.Prepaid),
  cardNumber: string().required(),
  // TODO: what rules should be applied?
  securityCode: string().required(),
  alias: string(),
});
